import { useDropzone } from 'react-dropzone';
import fileTypes from 'pools/fileTypes';
import { acceptStyle, activeStyle, rejectStyle } from 'pools/dropzoneStyles';
import { ReactComponent as FilesSvg } from 'assets/files.svg';
import { useContext, useEffect, useMemo } from 'react';
import ListItem from 'components/atoms/ListItem';
import { GlobalContext } from 'Context/GlobalContext/AppContext';
import './styles.scss';
import Button from 'components/atoms/Button';

function fileValidator(existingFiles, fileTypes) {
  return function (file) {
      let validated = null;
      
    const nameMessage = {
      code: 'file-exists',
      message: `Não é possível salvar arquivos com o mesmo nome. ${file.name} já existe no Servidor.`,
    };
    ////const typeMessage = {
    ////  code: 'wrong-file-type',
    ////  message: `Não é possível salvar arquivos do tipo ${file.name}. Arquivo não adicionado.`,
    ////};
    existingFiles.forEach((exFile) => {
      if (file.name === exFile.Nome) {
        validated = { ...nameMessage };
      }
    });

    ////if (!fileTypes.includes(file.type)) {
    ////  validated = { ...typeMessage };
    ////}
    return validated;
  };
}

const Dropzone = ({ setSelectedFiles, selectedFiles, setSelectedLinks, selectedLinks, existingLinks, setExistingLinks }) => {
  const { fileRejections, acceptedFiles, getRootProps, getInputProps, isDragActive, isDragAccept, isDragReject } = useDropzone({
    validator: fileValidator(existingLinks, fileTypes),
  });
  const { setResponseMsg } = useContext(GlobalContext);

  function filesToLinks(files) {
    return files.map((file) => ({ ID: 0, Nome: file.name, ContentType: file.type }));
  }

  function filterLink(links, actualLink) {
    return links.filter((selectedLink) => actualLink.Nome !== selectedLink.Nome);
  }

  function linksToItems(links, callback, removable) {
    return links?.map((link) => (
      <ListItem
        key={link.ID}
        id={link.ID}
        title={link.Nome}
        removable={removable}
        onRemove={() => callback((prevState) => filterLink(prevState, link))}
      />
    ));
  }

  const style = useMemo(
    () => ({
      ...(isDragActive ? activeStyle : {}),
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {}),
    }),
    [isDragActive, isDragAccept, isDragReject],
  );

  useEffect(() => {
    if (fileRejections.length > 0) {
      const { errors } = fileRejections[0];
      setResponseMsg({ isVisible: true, error: true, msg: errors[0].message });
    }
  }, [fileRejections, setResponseMsg]);

  useEffect(() => {
    if (acceptedFiles.length > 0) {
      setSelectedLinks(filesToLinks(acceptedFiles));
    }
    setSelectedFiles(acceptedFiles);
  }, [acceptedFiles, setSelectedFiles, setSelectedLinks]);

  useEffect(() => {
    if (selectedFiles.length > 0) {
      setSelectedLinks(filesToLinks(selectedFiles));
    }
  }, [selectedFiles, setSelectedLinks]);

  return (
    <>
      <div className="dropzone" {...getRootProps({ style })}>
        <FilesSvg className="dropzone__svg" />
        <input className="dropzone__input" {...getInputProps()} />
        <p className="dropzone__text">Arraste e solte os arquivos aqui ou clique para selecionar. </p>
      </div>
      <div className="dropzone__list">
        <h4 className="dropzone__title">Arquivos Novos Adicionados</h4>
        <ul className="dropzone__files">
          <div className="files__wrapper">{linksToItems(selectedLinks, setSelectedLinks)}</div>
        </ul>
        <Button
          visual="delete"
          onClick={() => {
            setSelectedFiles([]);
            setSelectedLinks([]);
          }}
        />
      </div>
      <div className="dropzone__existingFiles">
        <h4 className="dropzone__title">Arquivos Existentes</h4>
        <ul className="dropzone__files">
          <div className="files__wrapper">{linksToItems(existingLinks, setExistingLinks, true)}</div>
        </ul>
      </div>
    </>
  );
};

export default Dropzone;
